import { Button, Typography } from '@breetometer/components';
import { CurrencyBalance, WalletIcon } from 'BreetAssets';
import { capitalizeFirstLetters, CURRENCYCONFIG, type ReceiveCurrencyType } from 'BreetHelpers';
import { useCryptoSettings, useModalApi, useWalletBalance } from 'BreetHooks';
import { selectFiatMeta, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

const DialogSettlementWallet = () => {
	const { getBalance } = useWalletBalance();

	const { getModalProps } = useModalApi();

	const { selectedReceiveCurrency, handleCurrencyChange, hasUnsavedChanges, isUpdating, handleSaveChanges, saveChangesRef } =
		useCryptoSettings(true);

	const fiatMeta = useAppSelector(selectFiatMeta);

	const modalProps = getModalProps('settlementWallet') as { metadata: { fundingMethod: 'crypto' | 'fiat' } };

	const preferredCurrency = modalProps.metadata.fundingMethod === 'crypto' ? 'USD' : fiatMeta.currency;

	const currencyProps = CURRENCYCONFIG[preferredCurrency];

	const onChange = useCallback(
		(currencyType: ReceiveCurrencyType) => () => {
			handleCurrencyChange(currencyType);
		},
		[handleCurrencyChange]
	);

	const saveChanges = useCallback(() => {
		handleSaveChanges();
	}, [handleSaveChanges]);

	return (
		<div className='dialog-settlement-wallet bg-primary-500'>
			<WalletIcon variant='crypto-settings' />

			<Typography
				as='h5'
				className='color-tertiary-400'
			>
				Change Your Default Settlement Wallet
			</Typography>

			<Typography className='color-primary-50'>
				To continue, please change to your {capitalizeFirstLetters(currencyProps.currencyShort)} Wallet as your default settlement
				wallet in crypto settings.
			</Typography>

			<div className='currency-balance'>
				{fiatMeta.currency === 'NGN' && (
					<CurrencyBalance
						variant='NGN'
						balance={getBalance('NGN')}
						isSelected={selectedReceiveCurrency === 'ngn'}
						onClick={onChange('ngn')}
						className='svg-dark svg-dark-outline'
					/>
				)}

				{fiatMeta.currency === 'GHS' && (
					<CurrencyBalance
						variant='GHS'
						balance={getBalance('GHS')}
						isSelected={selectedReceiveCurrency === 'ghs'}
						onClick={onChange('ghs')}
						className='svg-dark svg-dark-outline'
					/>
				)}

				<CurrencyBalance
					variant='USD'
					balance={getBalance('USD')}
					isSelected={selectedReceiveCurrency === 'usd'}
					onClick={onChange('usd')}
					className='svg-dark svg-dark-outline'
				/>
			</div>

			<div className='currency-balance-cta'>
				<Button
					disabled={!hasUnsavedChanges || isUpdating}
					onClick={saveChanges}
					isLoading={isUpdating}
					ref={saveChangesRef}
				>
					Save Changes
				</Button>
			</div>
		</div>
	);
};

export default DialogSettlementWallet;
